import { makeStyles } from "@material-ui/core/styles";

// const lgUp = "60px";
// const lgDown = "48px";
const lgUp = "60px";
const lgDown = "50px";

export const useDSCStyles = makeStyles((theme) => ({
  table: {},
  root: {
    flexGrow: 1,
  },
  content: {
    position: "relative",
    marginTop: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  stickFooter: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 3px 0px 3px 0px, rgba(60, 64, 67, 0.15) 1px 0px 1px 0px",
  },
  stickHeader: {
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
  stickHeader2: {
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
  tableContainer: {
    // minHeight: `250px`,
  },
  thRow: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
  countField: {
    minWidth: lgDown,
    maxWidth: lgDown,
    color: "white",
    backgroundColor: theme.palette.primary.main,
  },
  hrsField: {
    minWidth: lgDown,
    maxWidth: lgDown,
    // backgroundColor: theme.palette.grey[200]
    // paddingRight: "4px",
  },
  staffField: {
    minWidth: lgDown,
    maxWidth: lgDown,
    // backgroundColor: theme.palette.grey[200]
    // paddingLeft: "4px",
  },
  capacity: {
    minWidth: lgDown,
    maxWidth: lgDown,
    fontSize: "12px",
    backgroundColor: "white",
  },
  average: {
    minWidth: lgDown,
    maxWidth: lgUp,
    // backgroundColor: theme.palette.grey[200]
  },
  colDate: {
    fontSize: "14px",
    textAlign: "center",
    width: 32,
    height: 32,
    borderRadius: "100%",
    background: "white",
    color: "black",
    lineHeight: "32px",
    // fontSize: "25px",
    letterSpacing: "-1.4px",
    textIndent: "-1.4px",
    fontVariant: "tabular-nums",
    fontFeatureSettings: `"tnum" 1`,
    // background-color: #1a73e8;
    // color: white;
  },
  productHrInp:{
    backgroundColor:"#FFFFFF",
    width:"65%",
    borderRadius:"5px"
  }
}));

export const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  countField: {
    minWidth: lgDown,
    maxWidth: lgDown,
  },
  hrsField: {
    minWidth: lgDown,
    maxWidth: lgDown,
    paddingRight: "4px",
  },
  staffField: {
    minWidth: lgDown,
    maxWidth: lgDown,
    paddingLeft: "4px",
  },
  capacity: {
    minWidth: lgDown,
    maxWidth: lgUp,
  },
  average: {
    minWidth: lgDown,
    maxWidth: lgUp,
  },
  thRow: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: "inherit",
    display:'flex',
    alignItems:'center'
  },
  [theme.breakpoints.up("xl")]: {
    countField: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
    hrsField: {
      minWidth: lgUp,
      maxWidth: lgUp,
      paddingRight: "4px",
    },
    staffField: {
      minWidth: lgUp,
      maxWidth: lgUp,
      paddingLeft: "4px",
    },
    capacity: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
    average: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
  },
  textField: {
    margin:'0px',
    '& .MuiInputBase-root':{
      padding:'2px 4px',
    // "&.Mui-focused fieldset": {
    //   border:'1px solid #0000003b'
    // }
    },
    // '& fieldset':{
    //   border:'none'
    // },
  },
  checkbox:{
    padding:'0 15px 0 0'
  }
}));
